<div class="status-legend-card">
  <div class="status-legend-header">
    <mat-icon>info</mat-icon>
    <h3>Legenda Badge Libretto</h3>
  </div>
  <div class="status-legend-content">
    <div class="legend-table-wrapper">
      <table class="legend-table">
        <thead>
          <tr>
            <th class="abbr-col">Sigla</th>
            <th class="name-col">Nome</th>
            <th class="desc-col">Descrizione</th>
            <th class="status-col">Stato Grigio</th>
            <th class="status-col">Stato Rosso</th>
            <th class="status-col">Stato Arancione</th>
            <th class="status-col">Stato Giallo</th>
            <th class="status-col">Stato Verde</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let badge of badges; trackBy: trackByAbbr">
            <td class="abbr-cell"><span class="badge">{{ badge.abbr }}</span></td>
            <td class="name-cell">{{ badge.name }}</td>
            <td>{{ badge.description }}</td>
            <td class="status-grey">{{ badge.grey }}</td>
            <td class="status-red">{{ badge.red }}</td>
            <td class="status-orange">{{ badge.orange }}</td>
            <td class="status-yellow">{{ badge.yellow }}</td>
            <td class="status-green">{{ badge.green }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="legend-note mt-3">
      <mat-icon>help_outline</mat-icon>
      <span>Un badge <strong>viola</strong> indica una relazione tecnica caricata e
        <strong>non conforme</strong>, oppure uno stato non gestito dal sistema.</span>
    </div>

    <div class="legend-note mt-2">
      <mat-icon>warning</mat-icon>
      <span>L'icona di <strong>avviso arancione</strong> accanto allo stato compare quando il libretto ha un
        alert attivo. Il dettaglio è nel tooltip dell'icona.</span>
    </div>
  </div>
</div>